import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../../../../../../shared/modal/modal.component';
import { ModalSize } from '../../../../../../shared/modal/modal-size.enum';
import { AcsService, AcsTokenResponse } from '../../../../../../core/services/acs.service';
import { AlertService } from '../../../../../../shared/alert/alert.service';
import { Observable } from 'rxjs';
import { LogHelper } from '../../../../../../core/helpers/log.helper';
import { AcsCallComponent } from '../../../../../../shared/acs-call/acs-call.component';

@Component({
  selector: 'app-call-modal',
  templateUrl: './call-modal.component.html',
  styleUrls: ['./call-modal.component.scss']
})
export class CallModalComponent {
  @ViewChild('callModal') callModal: ModalComponent;
  @ViewChild('acsCall') acsCall: AcsCallComponent;

  ModalSize = ModalSize;
  loading = false;
  ready = false;

  acsToken: string;
  acsUserId: string;
  roomId: string;
  displayName: string;

  constructor(
    private acsService: AcsService,
    private alertService: AlertService
  ) {}

  open(siteContactId: string, roomId: string, displayName: string): void {
    this.startCall(roomId, displayName, this.acsService.getToken(siteContactId));
  }

  private startCall(roomId: string, displayName: string, tokenSource: Observable<AcsTokenResponse>): void {
    this.loading = true;
    this.ready = false;
    this.roomId = roomId;
    this.displayName = displayName;
    this.callModal.show();

    tokenSource.subscribe({
      next: (tokenResponse) => {
        this.acsToken = tokenResponse.token;
        this.acsUserId = tokenResponse.acsUserId;
        this.loading = false;
        this.ready = true;

        // Give Angular a tick to render the acs-call component, then join
        setTimeout(() => {
          this.acsCall?.joinCall();
        });
      },
      error: (error) => {
        LogHelper.log(error);
        this.alertService.showWarningAlert('Unable to get call token.');
        this.loading = false;
        this.callModal.hide();
      }
    });
  }

  onCallEnded(): void {
    this.close();
  }

  onCallError(message: string): void {
    this.alertService.showWarningAlert(message || 'Call error occurred.');
    this.close();
  }

  close(): void {
    this.ready = false;
    this.acsToken = null;
    this.acsUserId = null;
    this.callModal.hide();
  }
}
